package fr.frux.core.billing

import kotlinx.coroutines.flow.Flow

/**
 * Port vers le store de la plateforme (#457). Seul Android en a un, derrière Play Billing. Il ne
 * parle jamais au serveur Frux et n'acquitte jamais : [StorePurchases] transmet les jetons, le
 * serveur relit l'achat chez Google et acquitte (ADR 0033).
 */
interface BillingPlatform {
    /** Ouvre la feuille de paiement du store pour Frux+, rattachée à [purchaseAccountRef]. */
    suspend fun launchPurchase(purchaseAccountRef: String): PurchaseFlowResult

    /** Achats Frux+ que le store connaît pour le compte Google de l'appareil. */
    suspend fun ownedPurchases(): Result<List<StorePurchase>>

    /** Un élément à chaque retour de l'app au premier plan, pour relancer le rattrapage (#548). */
    val foregrounds: Flow<Unit>
}

/** Achat tel que le store le décrit. Le jeton est la seule chose que le serveur reçoit. */
data class StorePurchase(
    val purchaseToken: String,
    /** Paiement différé : rien à transmettre, la notification de Google le confirmera. */
    val pending: Boolean,
    val acknowledged: Boolean,
)

sealed interface PurchaseFlowResult {
    /** La feuille s'est fermée sur un ou plusieurs achats. */
    data class Completed(
        val purchases: List<StorePurchase>,
    ) : PurchaseFlowResult

    /** Fermée par la personne : ce n'est pas une erreur à lui montrer. */
    data object Canceled : PurchaseFlowResult

    /** Le compte Google de l'appareil a déjà l'abonnement, peut-être jamais transmis au serveur. */
    data object AlreadyOwned : PurchaseFlowResult

    data class Failed(
        val error: Throwable,
    ) : PurchaseFlowResult
}
